import AuthIntializer from "src/store/selectors/AuthIntializer";

export default [AuthIntializer]